module.exports = __webpack_public_path__ + "img/account-protection.845300f6.svg";